module.exports = __webpack_public_path__ + "static/jess-Normal-141c471792efa18fb5c1005927ac5062.jpg";